import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { useTable, usePagination } from 'react-table'
import styles from './styles.module.scss'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import Pagination from 'srcReact/components/common2/Pagination'
import Spinner from 'srcReact/components/common2/Spinner'

const ReactTable = ({
  columns,
  data,
  className,
  loading,
  pagination,
  handleCurrentPage,
  pageSize = appConstantSettings.WORKPLACE_PAGINATION_QUANTITY
}) => {
  const { t } = useTranslation()
  const [currentPage, setCurrentPage] = useState(1)

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: pageSize }
    },
    usePagination
  )
  const handleOnPageChange = (page) => {
    setCurrentPage(page)
    handleCurrentPage(page)
  }

  useEffect(() => {
    //Documents page-if there is any update on any record on page which is not first page, then after success, show first page
    if (pagination.offset - pageSize === 0) {
      setCurrentPage(1)
    }
  }, [pagination.offset])

  return (
    <div className={`${styles.reactTableWrapper} ${className}`}>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps({
                    className: `${styles.columnClassName} ${column.className}`
                  })}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {loading ? (
            <tr>
              <td colSpan='10000'>
                <Spinner />
              </td>
            </tr>
          ) : (
            page.map((row, i) => {
              prepareRow(row)
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td
                        {...cell.getCellProps({
                          className: `${styles.cellColumnClassName} ${cell.column.className}`
                        })}>
                        {cell.render('Cell')}
                      </td>
                    )
                  })}
                </tr>
              )
            })
          )}
        </tbody>
      </table>
      {!loading && pagination.total > pageSize && (
        <div className={styles.pagination}>
          <div
            className={styles.showing}
            dangerouslySetInnerHTML={{
              __html: t('organizationSettings.pagination.showing', {
                current_page: `${pagination.offset - pageSize + 1} - ${
                  data.length < pageSize ? pagination.total : data.length * currentPage
                }`,
                total_count: pagination.total
              })
            }}
          />
          <Pagination
            className='pagination'
            currentPage={currentPage}
            totalCount={pagination.total}
            pageSize={pageSize}
            onPageChange={handleOnPageChange}
          />
        </div>
      )}
    </div>
  )
}

ReactTable.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  className: PropTypes.string,
  loading: PropTypes.bool,
  handleCurrentPage: PropTypes.func,
  pagination: PropTypes.object
}

ReactTable.defaultProps = {
  columns: [],
  data: [],
  totalCount: 0,
  className: '',
  loading: false,
  pagination: {
    offset: 0,
    total: 0
  },
  handleCurrentPage: undefined
}

export default ReactTable
